import {
  collection, query, where, getDocs, doc, setDoc
} from "firebase/firestore";
import { db } from "./firebase";

export const updateDailyStock = async (date, rawSku) => {
  const sku = rawSku.trim().toUpperCase();
  // Yesterday opening
  const y = new Date(date);
  y.setDate(y.getDate() - 1);
  const yDate = y.toISOString().slice(0, 10);

  let opening = 0;
  const ySnap = await getDocs(
    query(collection(db, "daily_stock"),
      where("date", "==", yDate),
      where("sku", "==", sku))
  );
  if (!ySnap.empty) opening = ySnap.docs[0].data().physicalStock || 0;

  const sumQty = async (col) => {
    const snap = await getDocs(
      query(collection(db, col),
        where("inwardDate", "==", date),
        where("sku", "==", sku))
    );
    return snap.docs.reduce((s, d) => s + (d.data().quantity || 0), 0);
  };

  const inward = await sumQty("inward_register");
  const outward = await sumQty("sales_invoices");
  const damage = await sumQty("damage_register");

  const systemStock = opening + inward - outward - damage;

  await setDoc(
    doc(db, "daily_stock", `${date}_${sku}`),
    {
      date,
      sku,
      openingStock: opening,
      inwardQty: inward,
      outwardQty: outward,
      damageQty: damage,
      systemStock,
      dayClosed: false
    },
    { merge: true }
  );
};
